export default {
    props: {
        name: {
            type: String
        },
        id: {
            type: String
        },
        disabled: {
            type: Boolean
        },
        required: {
            type: Boolean,
            default: false
        }
    }
};




//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/lib/mixins/form.js
// module id = 111
// module chunks = 2